import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { getElementHeight } from '@df/dom/fn/get-element-height';
import { BraintreeHostedFieldsComponentDef } from '@df/module-braintree/hosted-fields/braintree-hosted-fields.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CHECKOUT_SUBMIT_CLICK_EVENT_NAME } from '../../../checkout/checkout-form.component';
import { CheckboxComponent } from '../../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { HEADER_ID } from './../../../layout/page/header/page-header.component';
@Component({
    selector: 'braintree-hosted-fields',
    templateUrl: './braintree-hosted-fields.html',
    standalone: true,
    imports: [InputWrapComponent, InputWrapBodyDirective, FormsModule, NgClass, TranslationModule, CheckboxComponent],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class BraintreeHostedFieldsComponent extends BraintreeHostedFieldsComponentDef implements OnInit {
    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(
            this.app.events.on(CHECKOUT_SUBMIT_CLICK_EVENT_NAME).subscribe(() => {
                if (this.threeDSInProgress && this.threeDSInstance && this.threeDSContainerElement?.innerHTML) {
                    this.onThreeDSInit();
                }
            })
        );
    }
    protected override onThreeDSInit(): void {
        const container = this.threeDSContainerElement;
        const headerHeight = getElementHeight(`#${HEADER_ID}`);
        if (container) {
            this.scrollToService.scrollTo(container, headerHeight ? { offset: headerHeight } : undefined);
        }
    }
}
